const actionTypeIdentifier = 'KCY0V2SQ-F86P-49AG-M1BT-3XUJZEDRIWLH';

export const getRechargeInventoryDropdownList = `GET-RECHARGE-INVENTORY-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const setRechargeInventoryError = `SET-RECHARGE-INVENTORY-ERROR-${actionTypeIdentifier}`;
export const getActiveCircuits = `GET-ACTIVE-CIRCUITS-${actionTypeIdentifier}`
export const getMrcRechargeDropdown = `GET-MRC-RECHARGE-DROPDOWN-${actionTypeIdentifier}`
export const getRechargeViaDummyInvoiceDropdown = `GET-RECHARGE-DUMMY-INVOICE-DROPDOWN-${actionTypeIdentifier}`
export const resetRechargeInventoryForm = `RESET-RECHARGE-INVENTORY-FORM-${actionTypeIdentifier}`
export const getRechargeInventoryDetails = `GET-RECHARGE-INVENTORY-DETAILS-${actionTypeIdentifier}`
export const getMappingInformationList = `GET-MAPPING-INFORMATION-LIST-${actionTypeIdentifier}`;
export const addMappingInformation = `ADD-MAPPING-INFORMATION-ITEM-${actionTypeIdentifier}`;
export const updateMappingInformation = `UPDATE-MAPPING-INFORMATION-ITEM-${actionTypeIdentifier}`;
export const deleteMappingInformation = `DELETE-MAPPING-INFORMATION-ITEM-${actionTypeIdentifier}`;
export const getRechargeInventoryComments = `GET-RECHARGE-INVENTORY-COMMENTS${actionTypeIdentifier}`;
export const getRechargeInventoryLineItems = `GET-RECHARGE-INVENTORY-LINE-ITEMS${actionTypeIdentifier}`;
export const setRechargeLineItemsPageSize = `SET-RECHARGE-LINE-ITEMS-SIZE${actionTypeIdentifier}`;
export const setRechargeLineItemsColSearchStr = `SET-RECHARGE-LINE-ITEMS-COL-SEARCH${actionTypeIdentifier}`;
export const setSortRechargeLineItems = `SET-SORT-RECHARGE-LINE-ITEMS${actionTypeIdentifier}`;
export const setResetRechargeLineItems = `SET-RESET-RECHARGE-LINE-ITEMS${actionTypeIdentifier}`;
export const getCostCodeList = `GET-RECHARGE-COST-CODES${actionTypeIdentifier}`;
export const resetCostCodeList = `RESET-RECHARGE-COST-CODES${actionTypeIdentifier}`;

export const setRechargingEmployeeLoading = `SET-RECHARGING-EMPLOYEE-LOADING-${actionTypeIdentifier}`;
export const setRequestorOptions = `SET-REQUESTOR-OPTIONS-${actionTypeIdentifier}`;
export const setEndUserOptions = `SET-END-USER-OPTIONS-${actionTypeIdentifier}`;
export const setRechargingPersonOptions = `SET-RECHARGING-PERSON-OPTIONS-${actionTypeIdentifier}`;
export const setVendorLoading = `SET-VENDOR-LOADING-${actionTypeIdentifier}`;
export const setVendorOption = `SET-VENDOR-OPTION-${actionTypeIdentifier}`;
export const setLocationLoading = `SET-LOCATION-LOADING-${actionTypeIdentifier}`;
export const setLocationOption = `SET-LOCATION-OPTION-${actionTypeIdentifier}`;
export const setCircuitLoading = `SET-CIRCUIT-LOADING-${actionTypeIdentifier}`;
export const setCircuitOption = `SET-CIRCUIT-OPTION-${actionTypeIdentifier}`;
export const insertToRechargeComment = `INSERT-RECHARGE-COMMENT${actionTypeIdentifier}`;
export const resetRechargeComments = `RESET-RECHARGE-COMMENTS${actionTypeIdentifier}`;

export const rechargeInventoryDetailsModel = {
    // common field
    operationalStatusId: 1,
    rechargeInventoryType: "",
    vendorId: 0,
    vendorName: "",
    endUserId: 0,
    endUserEmail: "",
    requestorId: 0,
    requestorEmail: "",
    rechargePersonId: 0,
    rechargeQuantity: "1.00000",
    serviceInstanceId: "",
    outputRecordId: "", 
    rechargingInventoryId: 0
}

export const otcInformationModel = {
    otcNumber: "",
    otcDDI: "",
    otcTypeId: 0,
    activationDate: null,
}

export const circuitInformationModel = {
    circuitId: 0,
    circuitCode: "",
    circuitDDI: "",
    circuitTypeId: 0,
    circuitTypeName: "",
    orderTypeId: 0,
    installDate: null,
    hardwareCategoryId: 0
}

export const mappingInformationModel = {
    ArticleID: 0,
    DebitorID: 0,
    ArticleNumber: "",
    ArticleName: "",
    DebitorNumber: "",
    DebitorName: "",
    CostCenterID: 0,
    SalesOrganizationNumber: "",
    VatGroupID: 0,
    PriceCalculationID: 1,
    AdditionalAttribute: "",
    MappingStatusID: 1,
    MappingStatus: ""
}

export const additionalInformationModel = {
    // common
    requisition: "",
    basketRequisitionNumber: "",
    basketNumber: "",
    basketItemPosition: "",
    customerTag: "",
}

export const locationInformationModel = {
   locationId: 0,
   locationAddress: "",
   locationCountryCode: "",
   locationState: "",
   locationCode: ""
}

export const mrcInformationModel = {
    mrcRecharge: 0,
    mrcRechargeAmount: "0.00000",
    rechargeViaDummyInvoice: 0  ,
    dummyLineItemAmount: "0.00000",
    dummyInvoiceDate: null,
    dummyInvoiceDueDate: null
}

export const equipmentInformationModel = {
    equipmentNumber: "",
    equipmentDDI: "",
    equipmentTypeId: 0,
    orderTypeId: 0,
    deliveryDate: null,
    installDate: null,
    equipmentEndUserId: 0,
    equipmentRequestorId: 0,
    equipmentRechargingPersonId: 0,

}